import { getParents } from '@/lib/event'
import { Event } from '@nostr/tools/wasm'
import { atom, getDefaultStore } from 'jotai'

const store = getDefaultStore()

export const repliesMapAtom = atom<Map<string, Event[]>>(new Map())

export function addReplies(replies: Event[]) {
  store.set(repliesMapAtom, (prev) => {
    let next: Map<string, Event[]> = prev
    let touched = false
    for (const reply of replies) {
      const parentKeys = new Set<string>()
      for (const ptr of getParents(reply)) {
        const parent =
          'id' in ptr
            ? ptr.id
            : 'identifier' in ptr
              ? `${ptr.kind}:${ptr.pubkey}:${ptr.identifier}`
              : null
        if (parent) parentKeys.add(parent)
      }
      if (parentKeys.size === 0) {
        const q = reply.tags.find((t) => t[0] === 'q')?.[1]
        if (q) parentKeys.add(q)
      }

      for (const parent of parentKeys) {
        const prevEntries = next.get(parent) || []
        if (!prevEntries.find((evt) => evt.id === reply.id)) {
          if (!touched) {
            next = new Map(prev)
            touched = true
          }
          next.set(parent, [...prevEntries, reply])
        }
      }
    }
    return touched ? next : prev
  })
}

export function removeReplies(ids: Iterable<string>) {
  const idSet = new Set(ids)
  store.set(repliesMapAtom, (prev) => {
    let next: Map<string, Event[]> | null = null
    for (const [parent, events] of prev) {
      const filtered = events.filter((evt) => !idSet.has(evt.id))
      if (filtered.length !== events.length) {
        if (!next) next = new Map(prev)
        next.set(parent, filtered)
      }
    }
    return next ?? prev
  })
}
